export const defaultLocale = 'ar'
export const defaultDirection = 'rtl'
export const localeOptions = [
  { id: 'en', name: 'English LTR', direction: 'ltr' },
  { id: 'ar', name: 'Arab RTL', direction: 'rtl' },
]
